import { 
  Typography, 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function AmendDdsEndpoint() {
  const requestExample = `{
   "ddsIdentifier":"3903e249-44aa-4abe-a7a8-3066764d3455",
   "statement":{
      "internalReferenceNumber":"API-Amend001",
      "activityType":"DOMESTIC",
      "countryOfActivity":"HR",
      "borderCrossCountry":"AT",
      "comment":"Updated comment 2 - CF5 test",
      "commodities":{
         "descriptors":{
            "descriptionOfGoods":"Updated description of goods",
            "goodsMeasure":{
               "netWeight": 150000,
               "numberOfUnits": 1500
            }
         },
         "hsHeading":"0901",
         "speciesInfo":{
            "scientificName":"Quercus robur",
            "commonName":"Common oak"
         },
         "producers":{
            "country":"HR",
            "name":"Hrvatske šume d.o.o.",
            "geometryGeojson":"eyJ0eXBlIjoiRmVhdHVyZUNvbGxlY3Rpb24iLCJmZWF0dXJlcyI6W3sidHlwZSI6IkZlYXR1cmUiLCJwcm9wZXJ0aWVzIjp7IlByb2R1Y3Rpb25QbGFjZSI6InRleHQgcG9pbnQiLCJBcmVhIjo0Mzk0LjM1fSwiZ2VvbWV0cnkiOnsidHlwZSI6IlBvbHlnb24iLCJjb29yZGluYXRlcyI6W1tbLTguMDM3NzcxLDQwLjA0MzEyM10sWy04LjAzNzc3MSw0MC4wODMwNjNdLFstNy45MjE3NjIsNDAuMDgzMDYzXSxbLTcuOTIxNzYyLDQwLjA0MzEyM10sWy04LjAzNzc3MSw0MC4wNDMxMjNdXV19fV19"
         }
      },
      "geoLocationConfidential":false
   }
}`;

  const responseExample = `{
    "status": "success",
    "httpStatus": 200,
    "data": {
        "ddsIdentifier": "3903e249-44aa-4abe-a7a8-3066764d3455",
        "message": "DDS amended successfully"
    }
}`;

  return (
    <Box sx={{ textAlign: 'left', maxWidth: '900px' }}>
      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        EUDR SOAP Version 1.3 - REST API Implementation
      </Typography>

      <Typography variant="body1" paragraph sx={{ my: 3 }}>
        The Amend DDS endpoint allows modifications to existing Due Diligence Statements while 
        maintaining audit integrity. Amendments require full statement replacement and follow
        strict validation rules.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Base Endpoint
      </Typography>
      <CodeBlock code="PUT /api/eudr/dds" />

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Amendment Rules
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Key restrictions:
      </Typography>
      <ul>
        <li>Activity type cannot be modified from original submission</li>
        <li>Amendments only allowed within 90 days of initial submission</li>
        <li>Full statement replacement required (partial updates not supported)</li>
      </ul>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Request Requirements
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Mandatory Fields:
      </Typography>
      <ul>
        <li>ddsIdentifier (UUID + original reference/verification numbers)</li>
        <li>statement.internalReferenceNumber</li>
        <li>statement.operator.referenceNumber</li>
        <li>statement.commodities.hsHeading</li>
      </ul>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Example Request
      </Typography>
      <CodeBlock code={requestExample} />

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Response Structure
      </Typography>
      <CodeBlock code={responseExample} />

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Error Handling
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>HTTP Code</TableCell>
              <TableCell>Error Condition</TableCell>
              <TableCell>Resolution</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>409 Conflict</TableCell>
              <TableCell>Activity type modification attempt</TableCell>
              <TableCell>Maintain original activityType value</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>423 Locked</TableCell>
              <TableCell>DDS referenced in other statements</TableCell>
              <TableCell>Withdraw all references first</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>410 Gone</TableCell>
              <TableCell>Amendment window expired</TableCell>
              <TableCell>Submit new DDS statement</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default AmendDdsEndpoint; 